import type { FC } from "react";
import React, { useEffect, useContext } from "react";
import AppContext from "../../utils/appContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Footer from "../footer";
import CollectionsSwiper from "../collectionsswiper";
import SearchFilesHome from "../searchfileshome";
import GallerySwiper from "../galleryswiper";
import BrandingBrowser from "../brandingbrowser";

//files interface
interface filesProps {}
const HomePageSempre: FC<filesProps> = ({}) => {
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);
  const [visitorName, setVisitorName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user") || "{}"),
  );
  const [folderPath, setFolderPath] = useState<string>("/");
  const [counter, setCounter] = useState(0);
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const [groups, setGroups] = useState<Array<any>>([]);
  const [pressReleases, setPressReleases] = useState<Array<any>>([]);
  const [brandingPath, setBrandingPath] = useState<string>("/catalogues");

  const checkStatus = async () => {
    const storedJWT = localStorage.getItem("jwt");

    if (storedJWT) {
      await fetch(process.env.REACT_APP_API_URL + "/check-status.php", {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + storedJWT,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data == "success") {
            console.log("success");
            setLoading(false);
          } else {
            localStorage.clear();
            context?.updateLoginStatus(false);
            navigate("/login");
          }
        })
        .catch((error) => {
          // Handle network or server errors
          console.log("error");
          console.log(error);
          localStorage.clear();
          context?.updateLoginStatus(false);
          navigate("/login");
        });
    } else {
      console.log("not logged in");
      localStorage.clear();
      context?.updateLoginStatus(false);
      navigate("/login");
    }
  };

  const updateFolderPath = (path: string) => {
    setFolderPath(path);
  };
  const getgroups = async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-all-groups.php", {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //check if data is an array
        if (!Array.isArray(data)) {
          return;
        }
        setGroups(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const getPressReleases = async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-pressreleases.php", {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
      body: JSON.stringify({ limit: 2 }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check if data is an array
        if (!Array.isArray(data)) {
          return;
        }
        setPressReleases(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    checkStatus();
    getPressReleases();
    setPageLoaded(true);
  }, []);

  useEffect(() => {
    console.log(user);
    if (user.groups?.includes(0) || user.groups?.includes(1)) {
      getgroups();
    }
    user.firstname && setVisitorName(" " + user.firstname);
  }, [user]);

  const roles = JSON.parse(user.groups || "[]");
  const galleryArray = [
    // '/gallery/Sempre-banner-1.jpg',
    // '/gallery/Sempre-banner-2.jpg',
    "/gallery/Sempre-banner-3.jpg",
  ];
  const collectionsArray = [
    {
      image: "/collections-gallery/project-sempre-moscow.jpg",
      path: "/projects/sempre-moscow",
      title: "Sempre Moscow",
    },
    {
      image: "/collections-gallery/project-santoku-terrace.jpg",
      path: "/projects/santoku-terrace",
      title: "Santoku Terrace",
    },
    {
      image: "/collections-gallery/project-ronda-strand.jpg",
      path: "/projects/ronda-strand",
      title: "Ronda-strand",
    },
    {
      image: "/collections-gallery/project-maxwell-duxton-terrace.jpg",
      path: "/projects/maxwell-duxton-terrace",
      title: "Maxwell Duxton Terrace",
    },
    {
      image: "/collections-gallery/project-le-jardin-claude-quinquaud.jpg",
      path: "/projects/le-jardin-claude-quinquaud",
      title: "Le Jardin Claude Quinquaud",
    },
    {
      image: "/collections-gallery/project-la-bastide-dantoine.jpg",
      path: "/projects/la-bastide-dantoine",
      title: "La Bastide d'Antoine",
    },
    {
      image: "/collections-gallery/project-hotel-hanalei-bay.jpg",
      path: "/projects/hotel-hanalei-bay",
      title: "Hotel Hanalei bay",
    },
  ];
  return (
    pageLoaded && (
      <>
        <div className="px-5 lg:px-20 md:px-10">
          <div className="absolute h-[300px] md:h-[420px] lg:h-[550px] top-0 left-0 bg-black w-full z-0"></div>
          <div className="container mx-auto ">
            <div className="relative">
              <GallerySwiper images={galleryArray} />

              <div className="mt-5 w-[250px] md:w-[400px] absolute bottom-32 left-1/2 -translate-x-2/4 z-10">
                <SearchFilesHome path={folderPath} />
              </div>
            </div>
            <div className="mt-5 mb-10 md:mt-10 md:mb-20 lg:my-20 xl:mt-20 xl:mb-32">
              <div className="grid gap-5 lg:grid-cols-3 md:gap-7">
                <div
                  onClick={() => {
                    navigate("/files", { state: "/decoration" });
                  }}
                  className="px-8 py-8 cursor-pointer bg-shade"
                >
                  <div className="flex justify-start mb-5">
                    <img
                      src="./images/products-glassware.png"
                      className="inline-block max-h-44"
                      alt="Suzy"
                    />
                  </div>
                  <h2 className="mt-3 mb-2 text-xl md:text-2xl">Glassware</h2>
                  <p className="leading-tight text-gray-400 xl:text-lg">
                    Handblown in Europe, our glassware collection is a unique
                    blend of artistry and elegance.
                  </p>
                  <button className="flex items-center gap-2 mt-5 transition cursor-pointer hover:text-gray-500">
                    <span>view more</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-5 h-5 mt-1"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </button>
                </div>
                <div
                  onClick={() => {
                    navigate("/files", { state: "/indoor" });
                  }}
                  className="p-8 cursor-pointer bg-shade"
                >
                  <h2 className="mb-2 text-xl md:text-2xl">Furniture</h2>
                  <p className="leading-tight text-gray-400 xl:text-lg">
                    Each piece of furniture tells a story of raw materials,
                    craftsmanship and eco-conscious design.
                  </p>
                  <button className="flex items-center gap-2 my-5 transition cursor-pointer hover:text-gray-500">
                    <span>view more</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-5 h-5 mt-1"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </button>
                  <div className="mt-12">
                    <img src="./images/products-furniture.png" alt="Suzy" />
                  </div>
                </div>
                <div
                  onClick={() => {
                    navigate("/files", {
                      state: "/outdoor",
                    });
                  }}
                  className="grid content-between p-8 cursor-pointer bg-shade"
                >
                  <div>
                    <h2 className="mb-2 text-xl md:text-2xl">
                      Decoration & accessories
                    </h2>
                    <p className="leading-tight text-gray-400 xl:text-lg">
                      Our decorative pieces fuse natural textures, reclaimed
                      materials, and artisanal care.
                    </p>
                    <button className="flex items-center gap-2 my-5 transition cursor-pointer hover:text-gray-500">
                      <span>view more</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5 mt-1"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="flex justify-end ">
                    <img
                      src="./images/products-decoration-and-accessories.png"
                      className="max-h-48"
                      alt="Suzy"
                    />
                  </div>
                </div>
              </div>
            </div>
            {(roles.includes(0) || roles.includes(16)) && (
              <div className="my-10 md:my-20 lg:my-20 xl:my-32">
                <div className="flex items-center justify-between mb-3 md:mb-7">
                  <h2 className="flex flex-wrap min-h-[2rem]  gap-2  items-center text-xl md:text-2xl">
                    Projects
                  </h2>
                  <button
                    onClick={() => {
                      navigate("/files", { state: "/projects" });
                    }}
                    className="flex items-center gap-2 text-sm transition cursor-pointer md:text-base hover:text-gray-500"
                  >
                    <span>view more</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-5 h-5 mt-1"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </button>
                </div>
                <CollectionsSwiper collections={collectionsArray} />
              </div>
            )}
            <div className="my-10 md:my-20 lg:my-20 xl:my-32">
              <div className="mb-3 md:mb-7">
                <div className="flex justify-center ">
                  <div className="items-center hidden border border-gray-200 rounded-full lg:inline-flex">
                    <div>
                      <button
                        onClick={() => setBrandingPath("/catalogues")}
                        className={`${
                          brandingPath === "/catalogues"
                            ? "bg-shade border-gray-200 text-default"
                            : " text-gray-400 bg-white border-white"
                        } rounded-full text-sm border-l border-r px-4 py-2 transition`}
                      >
                        Catalogues
                      </button>
                    </div>
                    {(roles.includes(0) || roles.includes(12)) && (
                      <div>
                        <button
                          onClick={() => setBrandingPath("/branding/logo")}
                          className={`${
                            brandingPath === "/branding/logo"
                              ? "bg-shade border-gray-200 text-default"
                              : " text-gray-400 bg-white border-white"
                          } rounded-full text-sm border-l border-r px-4 py-2 transition`}
                        >
                          Logo
                        </button>
                      </div>
                    )}
                    {(roles.includes(0) || roles.includes(12)) && (
                      <div>
                        <button
                          onClick={() => setBrandingPath("/branding/fonts")}
                          className={`${
                            brandingPath === "/branding/fonts"
                              ? "bg-shade border-gray-200 text-default"
                              : " text-gray-400 bg-white border-white"
                          } rounded-full text-sm border-l border-r px-4 py-2 transition`}
                        >
                          Fonts
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-5 text-center lg:hidden">
                <div className="inline-flex items-center justify-center w-auto border border-gray-200 rounded-full">
                  <div>
                    <button
                      onClick={() => setBrandingPath("/catalogues")}
                      className={`${
                        brandingPath === "/catalogues"
                          ? "bg-shade border-gray-200 text-default"
                          : " text-gray-400 bg-white border-white"
                      } rounded-full text-xs md:text-sm border-l border-r px-3 py-1.5 md:px-4 md:py-2 transition`}
                    >
                      Catalogues
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => setBrandingPath("/branding/logo")}
                      className={`${
                        brandingPath === "/branding/logo"
                          ? "bg-shade border-gray-200 text-default"
                          : " text-gray-400 bg-white border-white"
                      } rounded-full text-xs md:text-sm border-l border-r px-3 py-1.5 md:px-4 md:py-2 transition`}
                    >
                      Logo
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => setBrandingPath("/branding/fonts")}
                      className={`${
                        brandingPath === "/branding/fonts"
                          ? "bg-shade border-gray-200 text-default"
                          : " text-gray-400 bg-white border-white"
                      } rounded-full text-xs md:text-sm border-l border-r px-3 py-1.5 md:px-4 md:py-2 transition`}
                    >
                      Fonts
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => setBrandingPath("/branding/colourguide")}
                      className={`${
                        brandingPath === "/branding/colourguide"
                          ? "bg-shade border-gray-200 text-default"
                          : " text-gray-400 bg-white border-white"
                      } rounded-full text-xs md:text-sm border-l border-r px-3 py-1.5 md:px-4 md:py-2 transition`}
                    >
                      Colourguide
                    </button>
                  </div>
                </div>
              </div>
              <BrandingBrowser
                folderPath={brandingPath}
                refreshCounter={counter}
                groups={groups}
              />
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  );
};
export default HomePageSempre;
